export var dialogStateActionTypes;
(function (dialogStateActionTypes) {
    dialogStateActionTypes["INITIAL_DIALOG_STATE"] = "INITIAL_DIALOG_STATE";
    dialogStateActionTypes["RECEIVE_DIALOG_STATE"] = "RECEIVE_DIALOG_STATE";
    dialogStateActionTypes["DIALOG_LOADING_STATE"] = "DIALOG_LOADING_STATE";
    dialogStateActionTypes["SILENT_LOADING_STATE"] = "SILENT_LOADING_STATE";
    dialogStateActionTypes["ABORTED_DIALOG_STATE"] = "ABORTED_DIALOG_STATE";
    dialogStateActionTypes["DIALOG_STATE_SAVED"] = "DIALOG_STATE_SAVED";
    dialogStateActionTypes["DIALOG_STATE_SAVE_FAILED"] = "DIALOG_STATE_SAVE_FAILED";
    dialogStateActionTypes["DIALOG_MESSAGES_SEND"] = "DIALOG_MESSAGES_SEND";
    dialogStateActionTypes["ERROR_DIALOG_STATE"] = "ERROR_DIALOG_STATE";
    dialogStateActionTypes["NO_CONNECTION_DIALOG_STATE"] = "NO_CONNECTION_DIALOG_STATE";
    dialogStateActionTypes["DIALOG_STATE_PRE_BOOK_SEND"] = "DIALOG_STATE_PRE_BOOK_SEND";
})(dialogStateActionTypes || (dialogStateActionTypes = {}));
export var initialDialogState = {
    type: dialogStateActionTypes.INITIAL_DIALOG_STATE
};
